<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/carInfo/',mdl_Request.get('strUnitID')?.value]"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">
            
            <span> {{ mdl_Request.get('strSubject')?.value }}  </span>
            
        </a>

    </div>

</div>

<main class="p-md-2 p-0">

    <div *ngIf="mdl_Request.get('strType')?.value == 2" class="p-1">

        <div [formGroup]="mdl_Request" class="container-fluid row gx-2 gy-2 p-2">

            <!-- از تاریخ -->

            <div class="col-12 col-md-3 position-relative">
    
                <label> از تاریخ </label>
    
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                    <input type="text" formControlName="strSDate" class="form-control text-end" />
    
                </ng-persian-datepicker>
    
            </div>

            <!-- تا تاریخ -->

            <div class="col-12 col-md-3 position-relative">
    
                <label> تا تاریخ </label>
    
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                    <input type="text" formControlName="strEDate" class="form-control text-end" />
    
                </ng-persian-datepicker>
    
            </div>

            <!-- جستجو -->

            <div class="col-12 col-md-auto">

                <button class="btn btn-primary" (click)="get_Report()"> 

                    &nbsp; جستجو &nbsp; 
                    
                </button>

            </div>

        </div>

    </div>

    <div class="border border-2 p-2">

        <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

        <ng-container *ngIf="mdl_Request.get('strType')?.value == 2">

            <p class="mb-0 my-2 px-1"> تعداد کل مسافرین : <strong class="text-danger"> {{ iPassengers | faNum }} نفر </strong> </p>

        </ng-container>

        <div class="section border border-2 mt-2" style="overflow: auto;" [ngStyle]="{'height': mdl_Request.get('strType')?.value == 2 ? 'calc(100vh - 240px)' : 'calc(100vh - 170px)'}">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <!-- گزارش مسافرین فعلی -->

                        <ng-container *ngIf="mdl_Request.get('strType')?.value == 1">

                            <th class="text-center col-1"> # </th>

                            <th class="text-center"> تصویر </th>

                            <th class="text-center"> نام </th>

                            <th class="text-center"> نام خانوادگی </th>

                            <th class="text-center"> ساعت سوار شدن </th>

                            <th class="text-center"> ایستگاه </th>

                        </ng-container>

                        <!-- گزارش سرجمع مسافرین -->

                        <ng-container *ngIf="mdl_Request.get('strType')?.value == 2">

                            <th class="text-center col-1"> # </th>

                            <th class="text-center"> تاریخ </th>

                            <th class="text-center"> روز </th>

                            <th class="text-center"> نوع خودرو </th>

                            <th class="text-center"> نام </th>

                            <th class="text-center"> پلاک </th>

                            <th class="text-center"> تعداد مسافر </th>

                        </ng-container>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <!-- گزارش مسافرین فعلی -->

                        <ng-container *ngIf="mdl_Request.get('strType')?.value == 1">

                            <td>{{ i + 1 | faNum }}</td>

                            <td class="">

                                <div class="d-flex justify-content-center">

                                    <div class="avatar-container border p-1">

                                        <img src="{{'data:image/jpeg;base64,'+item.strAvatar}}" alt="">

                                    </div>

                                </div>

                            </td>

                            <td> {{ item.strName | faNum }} </td>

                            <td> {{ item.strFamily | faNum }} </td>

                            <td> {{ item.strTime | faNum }} </td>

                            <td> {{ item.strRoute_Stations_strName | faNum }} </td>

                        </ng-container>

                        <!-- گزارش سرجمع مسافرین -->

                        <ng-container *ngIf="mdl_Request.get('strType')?.value == 2">

                            <td>{{ i + 1 | faNum }}</td>

                            <td> {{ item.strDate | faNum }} </td>

                            <td> {{ item.strDayName | faNum }} </td>

                            <td> {{ item.strMobileType_strComment | faNum }} </td>

                            <td> {{ item.strFullName | faNum }} </td>

                            <td> {{ item.strVehicleNo | faNum }} </td>

                            <td> {{ item.iPassengers | faNum }} </td>

                        </ng-container>
    
                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>